<script lang="ts">
  export let text: string
</script>

<div class="campaign-footer">
  <p>{text}</p>
</div>

<style lang="scss">
  p {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-size: 16px;
    opacity: 0.5;
  }
</style>
